
URL = globalThis.URL
import __vite__wasmUrl from "/home/cdiesh/src/logistic_chaos_map/logistic-map-wasm/pkg/index_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"
import * as __vite__wasmImport_0 from "./index_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./index_bg.js": { "__wbg_fillRect_c38d5d56492a2368": __vite__wasmImport_0["__wbg_fillRect_c38d5d56492a2368"],
"__wbg_floor_3206eb41fe582a22": __vite__wasmImport_0["__wbg_floor_3206eb41fe582a22"],
"__wbg_log_0e8ddf1fb1eaaf6e": __vite__wasmImport_0["__wbg_log_0e8ddf1fb1eaaf6e"],
"__wbg_max_0516851425d44529": __vite__wasmImport_0["__wbg_max_0516851425d44529"],
"__wbg_pow_35f95838ecd24e51": __vite__wasmImport_0["__wbg_pow_35f95838ecd24e51"],
"__wbg_random_3ad904d98382defe": __vite__wasmImport_0["__wbg_random_3ad904d98382defe"],
"__wbindgen_throw": __vite__wasmImport_0["__wbindgen_throw"],
"__wbindgen_init_externref_table": __vite__wasmImport_0["__wbindgen_init_externref_table"] } }, __vite__wasmUrl);
export const {
  memory,
  draw,
  __wbindgen_export_0,
  __wbindgen_start,
} = __vite__wasmModule;
